<template>
  <v-card class="pa-3">
    <v-card-title>
      Produkt Hinzufügen
    </v-card-title>
    <v-divider class="mb-3" />
    <v-form @submit.prevent="create()">
      <v-row>
        <v-col
          cols="12"
          lg="4"
        >
          <v-text-field
            v-model="createProductForm.name"
            outlined
            label="Name"
          />
        </v-col>
        <v-col
          cols="12"
          md="6"
          lg="4"
        >
          <v-select
            v-model="createProductForm.product_type_id"
            :items="productTypes"
            item-text="name"
            item-value="id"
            outlined
            label="Produkttyp"
          />
        </v-col>
        <v-col
          cols="12"
          md="6"
          lg="4"
        >
          <v-select
            v-model="createProductForm.tax_id"
            :items="taxes"
            item-text="name"
            item-value="id"
            outlined
            label="Steuern"
          />
        </v-col>
        <v-col cols="12">
          <v-textarea
            v-model="createProductForm.description"
            outlined
            label="Beschreibung"
          />
        </v-col>
        <v-col cols="12" class="d-flex justify-end">
          <v-btn type="submit" color="primary">
            Speichern
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
  </v-card>
</template>

<script>
export default {
   name: 'ProductCreate',
   props: {
      taxes: {
         type: Object,
         required: true
      },
      productTypes: {
         type: Object,
         required: true
      }
   },
   data () {
      return {
         createProductForm: this.$inertia.form({
            name: null,
            tax_id: null,
            product_type_id: null,
            description: null
         })
      }
   },
   methods: {
      create () {
         this.createProductForm.post(this.route('product.store'), {
            onSuccess: () => this.$emit('updated')
         })
      }
   }
}
</script>

<style></style>
